/**
 * Web Media Picker Implementation
 */

import type { MediaPickerType, PickMedia } from "./types";

const ACCEPT: Record<MediaPickerType, string> = {
  images: "image/png, image/jpeg",
  "images-and-videos": "image/png, image/jpeg, video/mp4, video/quicktime",
};

export const pickMedia: PickMedia = ({ type = "images" } = {}) =>
  new Promise((resolve) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ACCEPT[type];

    input.addEventListener("change", () => {
      const file = input.files?.[0];
      resolve(
        file
          ? { file, uri: URL.createObjectURL(file), isVideo: file.type.startsWith("video/") }
          : null,
      );
    });
    input.addEventListener("cancel", () => resolve(null));

    input.click();
  });
